import React from 'react';

const Spinner = props => (
  <div className="spinner_component"><div></div><div></div><div></div><div></div></div>
);

export default Spinner;



// WEBPACK FOOTER //
// ./source/client/components/common/interface/spinner.jsx